import {
  ChangeDetectionStrategy,
  Component,
  Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation
} from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { PreviewEditTemplateSelectors } from '../preview-edit-template/state/preview-edit-template.selectors';

@Component({
    selector: 'voice-message-new',
    templateUrl: './voice-message-new.component.html',
    styles: [`
      div.insert-parameter-dropdown {
        width: 60% !important;
        height: 36px !important;
        border: 1px solid #cccccc !important;
        background: white !important;
      }
    `],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})

export class VoiceMessageNewComponent implements OnChanges, OnInit {

    @Input() templateParameters;
    @Input() readonly isOnlyPreview: boolean;
    @Input() voiceContent;
    @Input() updatedModel;
    @Input() userPermissions;
    @Input() communicationsCategoryId;
    @Input() tabIndex;
    @Input() triggeredCategory;

    contextVariables$: Observable<any>;
    selectedTemplateParameter: any;
    selectedNode: any;
    displayTemplateParameters = [];
    cloneTemplate: any;
    isTwilioVoice = false;

    constructor(private previewEditTemplateSelectors: PreviewEditTemplateSelectors) {
        this.contextVariables$ = this.previewEditTemplateSelectors.selectGetContextVariable();
    }

    setSelectedIndex(event): void {
        this.selectedNode = event;
        // this is needed to enable cursor to  be displayed after template-context when last child
        if (Boolean(this.selectedNode.lastChild) && this.selectedNode.lastChild.localName === 'template-context') {
            const textnode = document.createTextNode('');
            this.selectedNode.appendChild(textnode);
        }
    }

    addParameter(event): void {
        const data = this.templateParameters.find(parameter => parameter.value === this.selectedTemplateParameter);
        document.execCommand('insertHTML', false, data.value);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.voiceContent !== undefined  && changes.voiceContent.currentValue !== undefined) {
            if (this.voiceContent.match(/<TwilioVoice/g)) {
                this.isTwilioVoice = true;
            }
        }

        if (changes.templateParameters !== undefined  || changes.triggeredCategory !== undefined) {
            if (this.templateParameters !== [] && this.templateParameters.length !== 0) {
                this.displayTemplateParameters = [...this.templateParameters];
                if (this.triggeredCategory === 'orders') {
                    const locationIndex = this.displayTemplateParameters.findIndex(templateParameter =>
                        templateParameter.label === 'location');
                    this.displayTemplateParameters.splice(locationIndex, 4);
                    const appointmentIndex = this.displayTemplateParameters.findIndex(templateParameter =>
                        templateParameter.label === 'appointment time'
                    );

                    this.displayTemplateParameters.splice(appointmentIndex, 4);
                }
                this.selectedTemplateParameter = this.templateParameters[0].value;
            }
        }
        if (this.updatedModel !== undefined && changes.tabIndex !== undefined && this.tabIndex === 2) {
            this.cloneTemplate = {...this.updatedModel};
        }
    }

    ngOnInit() {
        this.cloneTemplate = {...this.updatedModel};
    }
}
